import {IconButton, MenuItem, FormControl, Select, styled, Grid, InputAdornment, TextField, useTheme, useMediaQuery} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import ReactSelect from "react-select";

const filterStyles = {
    control: (styles, { isFocused }) => ({
        ...styles,
        textAlign: "left",
        backgroundColor: "#fff",
        minHeight: 20, 
        padding: "0 8px", 
        height: 34, 
        width: 280,
        fontSize: 14,
        borderColor: "rgb(122, 120, 247)",
        '&:hover': {
            borderColor: "rgb(122, 120, 247)", 
        },
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 1200,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999, 
    }),
    valueContainer: (styles) => ({
        ...styles,
        padding: "0px 6px",
    }),
    input: (styles) => ({
        ...styles,
        margin: 0,
        padding: 0, 
    }),
    option: (styles) => ({...styles, textAlign: "left", fontSize: 13}),
    dropdownIndicator: (styles) => ({
        ...styles,
        color: "rgb(122, 120, 247)", 
        marginTop: "-2px",
        '&:hover': {
            color: "rgb(122, 120, 247)",
        },
    }),
    clearIndicator: (styles) => ({
        ...styles,
        color: "rgb(122, 120, 247)", 
        marginTop: "-2px",
        '&:hover': {
            color: "rgb(122, 120, 247)", 
        },
    }),
    singleValue: (styles) => ({
        ...styles,
        color: "rgba(51, 51, 207, 0.808)",
        marginTop: "0px",
        fontSize: 13,
    }),
    placeholder: (styles) => ({ ...styles, color: "#3333CFCE", marginTop: "0px", fontSize: 12}), 
    noOptionsMessage: (provided) => ({
        ...provided,
        fontStyle: "italic", 
        textAlign: "start", 
        fontSize: "13px", 
    }),
}

const SmallSelect = styled(Select)(({theme, fontColor}) => ({
    minWidth: 120,  
    height: 33,   
    fontSize: '0.875rem', 
    '.MuiSvgIcon-root': {
        color: fontColor, 
    },
    color: fontColor,
    backgroundColor: '#fff',
    border: "1px solid #7A78F7",
    "& .MuiInputBase-root": { height: 33, border: "1px solid #7A78F7", color: "#3333CFCE", backgroundColor: '#fff', width: 250, borderRadius: "5px" },
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "& .MuiSelect-select": {
        fontSize: 12,
        fontStyle: 'italic'
    },
    "& .MuiMenuItem-root": {
        fontSize: 12,
    },
    "& .Mui-selected": {
        fontSize: 12,
        fontStyle: 'italic'
    },
}));

const ProductAuthenticationFilterComponent = (props) => {

    const {handleKeyDownProductType, product_type, product_name, handleKeyDownProductReference, product_reference, listProducts, handleSelectProductFilter} = props;

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isLargeScreen = useMediaQuery(theme.breakpoints.down('lg'));

    console.log("isMediumScreen", isMediumScreen)
    console.log("isSmallScreen", isSmallScreen)
    console.log("isLargeScreen", isLargeScreen)
    console.log("theme", theme)

    const product_types = [
        {value: "MPL"},
        {value: "BL"},
        {value: "RL"},
    ]

    return (
        <Grid container sx={{alignItems: "center"}}>
            <Grid item xs={12} lg={6} sx={{ display: 'flex', justifyContent: "flex-start", flexDirection: isSmallScreen ? 'column' : 'row'  }}>
                <ReactSelect
                    isRtl={false}
                     options={listProducts?.map(product => ({
                        label: product.product_name,
                        value: product.product_code
                    }))}
                    value={product_name}
                    onChange={selectedOption => handleSelectProductFilter(selectedOption)}
                    styles={filterStyles}
                    isClearable={true}
                    placeholder={(product_name) ? null : "Select Product Name"}
                    noOptionsMessage={() => "No matching product found."} 
                    menuPortalTarget={document.body} 
                    menuPosition="fixed"
                />
                
                &nbsp;&nbsp;&nbsp;&nbsp;
      
                <FormControl sx={{ width: 250 }}>
                    <SmallSelect
                        value={product_type}
                        onChange={handleKeyDownProductType}
                        displayEmpty
                        fontColor={"#5d5ed8"}
                        startAdornment={
                            <InputAdornment position="start">
                                <p style={{ fontSize: 12, margin: 0, color: "#3333CFCE", fontWeight: 'bold' }}>
                                    Product Type:
                                </p>
                            </InputAdornment>
                        }
                        endAdornment={
                            product_type && (
                                <InputAdornment position="end" sx={{mr: "10px"}}>
                                    <IconButton
                                        onClick={() => handleKeyDownProductType({target: {value: ""}})}
                                        size="small"
                                        aria-label="clear product type"
                                    >
                                        <ClearIcon sx={{fontSize: 16}} />
                                    </IconButton>
                               
                                </InputAdornment>
                            )
                        }
                        sx={{
                            color: (product_type) ? "#3333CFCE" : "#c8c8f2", 
                            '& .MuiSelect-select:empty': {color: "#c8c8f2"},
                        }}
                    >
                        <MenuItem value="" disabled sx={{ fontSize: 12 }}>
                            <em>Select Product Type</em>
                        </MenuItem>
                        
                        {product_types?.map((type, index)=>{
                            return(
                                <MenuItem value={type.value} sx={{fontSize: 12}}>
                                    {type.value}
                                </MenuItem>
                            )
                        })}
                    </SmallSelect>
                </FormControl>
            </Grid>

            <Grid item xs={12} lg={6} sx={{ display: 'flex', justifyContent: isSmallScreen || isMediumScreen || isLargeScreen ? "flex-start" : "flex-end", mt: isSmallScreen || isMediumScreen || isLargeScreen ? 2 : {} }}>
                <TextField
                    defaultValue={product_reference}
                    onKeyDown={handleKeyDownProductReference}
                    sx={{
                        "& .MuiInputBase-root": { height: 33, border: "1px solid #7A78F7", color: "#3333CFCE", backgroundColor: '#fff', width: 280, borderRadius: "5px" },
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                    }}
                    variant="outlined"
                    autoComplete="off"
                    inputProps={{ style: { padding: "5px 12px", fontSize: 12, fontStyle: 'italic' }, border: "1px solid #7A78F7" }}
                    placeholder="Search Reference"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <p style={{ fontWeight: 'bold', fontSize: 12, margin: 0, color: "#3333CFCE" }}>OVCode Reference:</p>
                            </InputAdornment>
                        ),
                    }}
                />
                {/* &nbsp;&nbsp;&nbsp;&nbsp;
                <TextField
                    sx={{
                        "& .MuiInputBase-root": { height: 33, border: "1px solid #7A78F7", color: "#3333CFCE", backgroundColor: '#fff', width: 250, borderRadius: "5px" },
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                    }}
                    variant="outlined"
                    autoComplete="off"
                    inputProps={{ style: { padding: "5px 12px", fontSize: 12, fontStyle: 'italic' }, border: "1px solid #7A78F7" }}
                    placeholder="Search Status"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <p style={{ fontWeight: 'bold', fontSize: 12, margin: 0, color: "#3333CFCE" }}>Status:</p>
                            </InputAdornment>
                        ),
                    }}
                /> */}
            </Grid>
        </Grid>
    )

}

export default ProductAuthenticationFilterComponent